module.exports = __webpack_public_path__ + "img/banner_left.1c25e2bf.png";